import { Eyebrow } from '../brand';
import { useLang } from '../lang';
import { DemoForm } from '../sections/DemoForm';
import { Faq } from '../sections/Faq';

export function Demo() {
  const { t } = useLang();
  return (
    <>
      <section className="band demo" id="top" aria-labelledby="demo-title">
        <div className="frame request-grid">
          <div className="request-copy">
            <Eyebrow k="demo.eyebrow" />
            <h1 id="demo-title" className="display">
              {t('demo.title')}
            </h1>
            <p className="lead">{t('demo.lead')}</p>
            <dl className="demo-lines">
              {(['waste', 'vision'] as const).map((line) => (
                <div key={line}>
                  <dt className="mono" translate="no">
                    {t(`line.${line}`)}
                  </dt>
                  <dd>{t(`demo.${line}.body`)}</dd>
                </div>
              ))}
            </dl>
          </div>
          <DemoForm />
        </div>
      </section>
      <Faq prefix="faq" />
    </>
  );
}
